import { Module } from "vuex-smart-module"

import UserState from "./state"
import UserMutations from "./mutations";
import UserGetters from "./getters";
import UserActions from "./actions"

export const userModule = new Module({
    state: UserState,
    getters: UserGetters,
    mutations: UserMutations,
    actions: UserActions
})